import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface WordmarkProps {
    className?: string
}

export const Wordmark: FC<WordmarkProps> = ({ className }): ReactNode => {
    return (
        <span className={cn('inline-flex items-baseline gap-1 font-heading text-[1.65rem] leading-none tracking-tight text-ink', className)}>
            <span>
                Un
                <span className='italic'>slop</span>
            </span>
            <span className='inline-block size-[0.32em] translate-y-[-0.05em] rounded-full bg-signal' aria-hidden='true' />
        </span>
    )
}
